<template>
  <el-card>
    <div>
      <!-- 标签管理 -->
      <!--      标签管理-->
      <el-row type="flex" justify="space-between">
        <el-input clearable @keydown.enter.native="searchthis" style="width:250px" placeholder="标签分类" v-model="name">
          <el-button slot="append" icon="el-icon-search" @click="searchthis()">搜索</el-button>
        </el-input>
        
        <div>
          <el-button @click="getAll()">一键统计</el-button>
          <el-button type="primary" @click="dialogFormVisible = true">添加标签分类</el-button>
        </div>

        <el-dialog title="添加标签分类" :visible.sync="dialogFormVisible">
          <el-form :model="addtag">
            <el-form-item label="标签分类名称" :label-width="formLabelWidth">
              <el-input autocomplete="off" v-model="addtag.name"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="tagAdd()">确 定</el-button>
          </div>
        </el-dialog>
      </el-row>
      <el-table border :data="tableData" style="width: 100%;margin-top:20px;">
        <el-table-column prop="name" label="分类" width="180"></el-table-column>
        <el-table-column prop="tagCount" label="分类下标签数"></el-table-column>
        <el-table-column prop="videoCount" label="分类下视频数"></el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button type="text" @click="editthis(scope.row)" size="small">编辑</el-button>
            <el-button type="text" @click="deletetag(scope.row)" size="small">删除</el-button>
            <el-button type="text" @click="sumtag(scope.row)" size="small">统计</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top:20px;"
        @current-change="handleCurrentChange"
        :page-size="limit"
        :current-page="page"
        background
        layout="prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <div style="height: 50px"></div>
  </el-card>
</template>


<script>
import qs from "qs";
export default {
  data() {
    return {
      name: "",
      page: 1,
      total: 0, // 分页总数
      limit: 20,
      tableData: [],
      dialogFormVisible: false,
      formLabelWidth: "120px",
      addtag: {
        id: "",
        name: ""
      }
    };
  },
  methods: {
    getTagGroupData: async function() {
      var name1 = this.name;
      var res = await this.$http.get(
        `/v1/tagGroupInfo/list?page=${this.page}&name=${this.name}`
      );
      var { code, message, data, total } = res.data;
      if (code == 0) {
        this.tableData = data;
        this.total = total;
      }
    },
    tagAdd: async function() {
      var res = await this.$http.post(
        `/v1/tagGroupInfo/addOrEdit?name=${this.addtag.name}&id=${this.addtag.id}`
      );
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$message.success("添加/编辑成功");
        this.dialogFormVisible = false;
        this.getTagGroupData();
        this.addtag.id = "";
        this.addtag.name = "";
      } else {
        this.$message.error(message);
      }
    },
    deletetag: function(row) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var id = row.id;
          var res = await this.$http.post(`/v1/tagGroupInfo/delete?id=${id}`);
          var { data, message, code } = res.data;
          if (code == 0) {
            this.$message.success("删除成功");
            this.getTagGroupData();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除"
          // });
        });
    },
    editthis: async function(row) {
      this.addtag.id = row.id;
      this.addtag.name = row.name;
      this.dialogFormVisible = true;
    },
    sumtag: async function(row) {
      var id = row.id;
      var res = await this.$http.get(`/v1/tagGroupInfo/countById?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$message.success("统计成功");
        this.getTagGroupData();
      }
    },
    handleCurrentChange: function(val) {
      // console.log(val)
      this.page = val;
      // console.log(this.page)
      this.getTagGroupData();
    },
    getAll: async function() {
      var res = await this.$http.get(`/v1/tagGroupInfo/countSum`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$message.success("统计成功");
        this.getTagGroupData();
      } else {
        this.$message.error(message);
      }
    },
    searchthis: function() {
      this.page = 1;
      this.getTagGroupData();
    }
  },
  mounted() {
    this.getTagGroupData();
  },
  watch: {
    dialogFormVisible: {
      handler: function(newName, oldName) {
        if (newName == false) {
          this.addtag.id = "";
          this.addtag.name = "";
        }
      }
    },
    tableData: {
      handler(newName, oldName) {
        if (this.total == (this.page - 1) * this.limit && this.total != 0) {
          //这一行是关键代码，倍数关系
          this.page -= 1;
          this.getTagData(); //获取表格数据的方法
        }
      },
      // tableData() {  //注意这个函数的名字必须和你监听data中的属性的名字一样，这样才能当你data中的属性发生变化时，触发这个函数
      //   if (this.total == (this.currentPage - 1) * this.pageSize && this.total != 0) { //这一行是关键代码，倍数关系
      //     this.currentPage -= 1
      //     this.getTagData()//获取表格数据的方法
      //   }
      // },
      deep: true
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/tag-mg/tagGroup.vue